import { COLORS } from 'constants/colors'
import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 300px;
  width: 212px;
  padding: 16px;

  border: 1px solid #ebebeb;
  border-radius: 12px;

  transition: all 0.2s;
  &:hover {
    border-color: ${COLORS.primary.light};
  }

  cursor: pointer;
`

export const ImageContainer = styled.div`
  position: relative;
  margin-bottom: 12px;
`

export const Image = styled.img`
  width: 180px;
  height: 180px;

  object-fit: cover;
  object-position: center;

  border-radius: 12px;
`

export const PlayerController = styled.div`
  position: absolute;
  bottom: 12px;
  right: 12px;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 50%;
  background: #ffffff;

  cursor: pointer;
`

export const TitleRow = styled.div`
  display: flex;
  align-items: center;

  margin-bottom: 6px;
`

export const Number = styled.p`
  font-weight: 600;
  font-size: 16px;
  line-height: 1.2;
  color: ${COLORS.text.hint};

  margin-right: 2px;

  white-space: nowrap;
`

export const Title = styled.p`
  font-weight: 600;
  font-size: 16px;
  line-height: 1.2;
  color: ${COLORS.text.default};

  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`

export const Subtitle = styled.p`
  font-size: 14px;
  line-height: 1.3;
  color: ${COLORS.text.hint};

  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`

export const SeriesTitle = styled.span<{ color?: string }>`
  color: ${({ color }) => color || COLORS.text.default};
`

export const MetaInfo = styled.p`
  font-size: 14px;
  line-height: 1.4;
  color: ${COLORS.text.default};

  margin-top: auto;

  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`
